// removed by extract-text-webpack-plugin
module.exports = {"block":"block_r7ZC1","container":"container_1OjwD","banner":"banner_26MPV"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/container/applyFixed/style.css
 ** module id = 940
 ** module chunks = 0
 **/